import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://fideliz-dev.onrender.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Ajouter un intercepteur pour inclure le token dans les requêtes
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Récupère le token du localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Ajoute le token dans l'en-tête Authorization
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Routes publiques qui ne doivent JAMAIS rediriger vers /login en cas de 401
// (par exemple la page d'activation pro accessible via un token email).
const PUBLIC_PATH_PREFIXES = ['/activation/', '/paiement/', '/personalization/', '/forgot-password', '/reset-password'];

// Gérer les erreurs globales
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const isOnPublicPath = PUBLIC_PATH_PREFIXES.some((p) =>
        window.location.pathname.startsWith(p)
      );
      if (!isOnPublicPath) {
        // Déconnecter l'utilisateur si le token est invalide ou expiré
        localStorage.removeItem('token');
        // Rediriger vers la page de login si on n'y est pas déjà
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;